import { useMutation, useQuery } from 'react-query';

import {
  type MutationFunction,
  QueryFunction,
  useRequest,
} from '@frontend/api';

export type MaterialRealTimePricingSettingsData = {
  olmAccountId?: string;
  tkAccountId?: string;
};

type MaterialRealTimePricingSettingsKey = readonly [
  'suppliers',
  'materialRealTimePricingSettings',
];

export const getMaterialRealTimePricingSettingsKey =
  (): MaterialRealTimePricingSettingsKey => [
    'suppliers',
    'materialRealTimePricingSettings',
  ];

export const useUpdateMaterialRealTimePricingSettings: MutationFunction<
  MaterialRealTimePricingSettingsData,
  MaterialRealTimePricingSettingsData
> = ({ requestOptions, queryOptions } = {}) => {
  const urlPath = `/suppliers/material_real_time_pricing_settings`;
  const request = useRequest(requestOptions);

  return useMutation((body) => {
    return request(urlPath, {
      init: {
        method: 'PUT',
        body: body,
      },
    });
  }, queryOptions);
};

export const useGetMaterialRealTimePricingSettings: QueryFunction<
  MaterialRealTimePricingSettingsData,
  [],
  MaterialRealTimePricingSettingsKey
> = ({ requestOptions, queryOptions } = {}) => {
  const queryKey = getMaterialRealTimePricingSettingsKey();
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/suppliers/material_real_time_pricing_settings`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
